<template>
  <div class="mt-5" v-if="photos && photos.length > 0">
    <HeaderBar :title="$t('pages.checkins_detail.all_photos')"/>
    <div class="container">
<!--      <view-loader :padding-classes="'py-6'" v-if="photos.length === 0 "/>-->
      <div class="position-relative" :class="{'collage-photo--clipped': showBlender}">
        <all-photos-list :checkin="checkin"
                         :medias="photos"
                         @nextPage="load"
                         :page="page"
                         :total-medias="totalMedias" />

        <div style="height: 36px" class="text-center mt-2">
          <div v-show="hasNextPage">
            <view-loader :padding-classes="'py-2'" v-if="loading"/>
            <b-button @click="load()" variant="primary" size="sm" v-else>
              {{ $t('pages.checkins_detail.load_more') }}
              <Icon name="plus" width="16" vertical-align="sub"/>
            </b-button>
          </div>
        </div>
        <transition name="fade">
          <div class="collage-photo__blender" v-if="showBlender">
            <b-button @click="show()" variant="primary" size="sm" v-show="showBlender">
              {{ $t('pages.checkins_detail.show_all_photos') }}
              <Icon name="plus" width="16" vertical-align="sub"/>
            </b-button>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>


<script>
import ViewLoader from "@/components/ViewLoader.vue";
import {mapActions, mapGetters, mapMutations} from "vuex";
import AllPhotosList from "@/domain/galleries/allPhotos/AllPhotosList.vue";
import HeaderBar from "@/domain/galleries/components/HeaderBar.vue";

export default {
  name: 'AllPhotos',
  components: {
    HeaderBar,
    AllPhotosList,
    ViewLoader
  },
  data() {
    return {
      loading: false,
      loadingSection: true,
      page: 1,
      showBlender: true,
      observer: null
    }
  },

  props: {
    checkin: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('mediaAllPhotos', ['photos', 'pagination']),
    hasNextPage() {
      return this.pagination.page_number <  this.pagination.num_pages || this.pagination.total === 0
    },
    totalMedias() {
      return this.pagination.total
    },
    page_size() {
      return this.pagination.page_size
    },
  },
  mounted() {
    this.resetPagination()
    this.load()
  },
  methods: {
    ...mapActions('mediaAllPhotos', ['fetchPhotos']),
    ...mapMutations('mediaAllPhotos', ['resetPagination']),
    async show() {
      this.showBlender = false
      //await this.load()
    },
    async load() {
      if (this.loading || !this.hasNextPage) return
      this.loading = true

      const params = {page: this.page, page_size: this.page_size}
      await this.fetchPhotos({checkin_id: this.checkin.id, params: params})

      this.page++

      this.loading = false
      this.loadingSection = false
    }
  },
  
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }
}
</script>

